import React from 'react';
import { useEffect, useState } from "react";
import apiAdm from "../../../services/apiAdm.js";
import DataTable from "react-data-table-component";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { SweetAlertSuccess, SweetAlertError, SweetAlertConfirm } from '../../../components/sweetAlert/swetAlert.jsx';
import {  FiEdit2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
 

function ListaUsuario() {
    const navigate = useNavigate();

    const [pageSize, setPageSize] = useState(10);
    const [dados, setDados] = useState([]);
    const [page, setPage] = useState(0);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [loading, setLoading] = useState(false);

    const columns = [
        {
            name: 'Nome',
            selector: row => row.Usuario.nome,
            sortable: true,
            width: '30%'
        },
        {
            name: 'email',
            selector: row => row.Usuario.login,
            sortable: true,
            width: '30%'
        },
        {
            name: 'Criado em',
            selector: row => row.Usuario.dtInclusao,
            sortable: true,
            width: '20%',
            format: row => new Intl.DateTimeFormat('pt-BR',
                {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                }).format(new Date(row.Usuario.dtInclusao)),
            center: true

        },
        {
            name: 'Status',
            cell: row =>
              <>
                {row.Usuario.isAtivo == 'S' ?
                  <span className="badge bg-success">Ativo</span>:
                    <span className="badge bg-danger">Inativo</span>
                  }
              </>,
            sortable: true,
            width: "8%",
          
        },
        {
            name: 'Ações',
            cell: (row) => <>
      
              <button type="button" style={{ height: '26px', width: '26px' }} 
                className='btn btn-sm btn-icon btn-outline-primary rounded-circle mr-2'
                title='Editar'
                onClick={() => Editar(row.Usuario.id)}
                    >
                <FiEdit2 /> 
              </button>

            </>,
      
            width: "8%",        // width: "150px",
            center: true
          }
    ];

    const paginationOptions = {
        rowsPerPageText: 'Registros por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: false,
        selectAllRowsItemText: 'Todos'
    };


    function ChangePerRows(newQtd) {
        setPageSize(newQtd);
        Listar();

    }

    function ChangePage(page) {
        setPage(page);
        Listar();
    }

    useEffect(() => {
        Listar();
    }, []);

    function Adicionar(){
        navigate('/CrudUsuario/0');
    };
    function Editar(id){
        navigate('/CrudUsuario/'+id);
    };
    
    function Listar() {
        let idCliente = localStorage.getItem('idEmpresa');
        setLoading(true);
        apiAdm.get("/usuarioentidade",
            {
                params: { idCliente }
            }
        )
            .then((resp) => {
                console.log(resp.data.usuarioEntidade);
                setTotalRegistros(resp.data.count);
                setDados(resp.data.usuarioEntidade);
                setLoading(false);
            })
            .catch((err) => {
                setTotalRegistros(0);
                setDados([]);
                SweetAlertError({ texto: 'Erro ao carregar as Notas de entradas' });
            });
    };

    return <>
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0"></div>

                <div class="row">
                    <div className="col-md-10 py-3">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="text-muted mb-3">Usuários</h5>

                                <div div className="row mb-3">
                                        <div className="btn-opcoes col-md-12" style={{ textAlign: 'right' }}>

                                            <button type="button" className="btn btn-primary "
                                                onClick={() => Adicionar()}>
                                                <span> Adicionar Usuário </span>
                                            </button>
                                        </div>

                                    </div>

                            </div>
                            {/* Tabela */}
                            <br></br>
                            <DataTable className="dataTables_wrapper"
                                columns={columns}
                                data={dados}
                                pagination={true}
                                paginationComponentOptions={paginationOptions}
                                noDataComponent={loading ? <Spinner animation="border" variant="primary" /> :
                                    <p className="no-data-found">Nenhum registro encontrado</p>
                                }
                                paginationServer={true}
                                paginationTotalRows={totalRegistros}
                                highlightOnHover
                                pointerOnHover
                                dense
                                onChangeRowsPerPage={ChangePerRows}
                                onChangePage={ChangePage}
                            />

                        </div>
                    </div>
                </div>


                <div class="modal" id="modalAdicionar" role="dialog" tabindex="-1">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Adicionar usuário</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="btn-close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <label class="form-label col-4">Nome</label>

                                </div>
                                <div class="row">
                                    <label class="form-label col-4">e-mail</label>

                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-primary float-end mr-1"
                                    id="BTN_ADICIONAR" data-bs-dismiss="modal">Adicionar</button>
                                <button type="button" class="btn btn-outline-secondary float-end mr-1" data-bs-dismiss="modal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </>
};

export default ListaUsuario;